export default [
  {
    path: '/goodsManage/GoodsList',
    name: 'goodsList',
    component: () => import('@/views/goodsManage/GoodsList'),
    meta: { title: 'menu.goodsList', keepAlive: true, permission: ['table'] },
  },
  {
    path: '/goodsManage/CreateGoods',
    name: 'createGoods',
    component: () => import('@/views/goodsManage/CreateGoods'),
    meta: { title: 'menu.createGoods', keepAlive: true, permission: ['form'] },
  },
  {
    path: '/goodsManage/GoodsDetail',
    name: 'goodsDetail',
    component: () => import('@/views/goodsManage/CreateGoods'),
    meta: { title: 'menu.goodsDetail', keepAlive: true, permission: ['form'] },
  },
  {
    path: '/goodsManage/ProductEdit',
    name: 'productEdit',
    component: () => import('@/views/goodsManage/CreateGoods'),
    meta: { title: 'menu.productEdit', keepAlive: true, permission: ['form'] },
  },
]
